<template>
  <div style="height: calc(100vh - 196px);">
    <vxe-toolbar
      id="toolbarId_bc12"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button
          v-if="!parentData.isDetail"
          @click="funcAdd('add')"
        >
          新增
        </el-button>
        <el-button @click="funcExport">
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="80%"
      :data="tableData"
      :loading="loading"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column>
        <vxe-table-column
          min-width="130"
          field="consignorAddress"
          title="装货地址"
          sortable
        />
        <template v-slot:header>
          <el-cascader
            v-model="consignorAreaList"
            :options="parentData.areaOptions"
            :props="{ value: 'countyCode', label: 'countyName' }"
            clearable
            placeholder="请选择装货地址"
            @change="changeConsignorAreaList"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          min-width="130"
          field="consignorDetailAddress"
          title="详细装货地址"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.consignorDetailAddress"
            placeholder="详细装货地址"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          min-width="130"
          field="consigneeAddress"
          title="收货地址"
          sortable
        />
        <template v-slot:header>
          <el-cascader
            v-model="consigneeAreaList"
            :options="parentData.areaOptions"
            :props="{ value: 'countyCode', label: 'countyName' }"
            clearable
            placeholder="请选择收货地址"
            @change="changeConsigneeAreaList"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          min-width="130"
          field="consigneeDetailAddress"
          title="详细收货地址"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.consigneeDetailAddress"
            placeholder="详细收货地址"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column
        v-if="!parentData.isDetail"
        title="操作"
        width="100"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcAdd('edit',scope.row.code)"
            >
              <i class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="删除"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcDelete(scope.row.code)"
            >
              <i class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :page-sizes="Pagingconf"
      :total="listQuery.total"
      :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="modelAddFlag"
      :title="modalTitle"
      width="800"
      height="500"
      resize
    >
      <compAdd
        ref="addRef"
        :area-options="parentData.areaOptions"
        @fatherAddMethod="fatherAdd"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import compAdd from "./components/commonRouteInfoAdd.vue";
import { getCommonRouteInfoList, delCommonRouteInfo } from "@/api/shipment";
export default {
  name: "DriverCommonRouteInfoList",
  components: {
    compAdd,
  },
  props: {
    parentData: {
      type: Object,
      default() {
        return {
          isDetail: false,
          areaOptions: []
        };
      }
    }
  },
  data() {
    return {
      exportObj:{
        exportUrl:"/ntocc-basic-api/commonRouteInfo/exportCommonRouteInfo",//导出接口
        name:'常跑线路'
      },
      loading: false,
      consignorAreaList: [],
      consigneeAreaList: [],
      tableData: [],
      modelAddFlag: false,
      modalTitle: '新增',
      copy: false,
      listQuery: {
        userCode: "",
        consignorProvinceCode: "",
        consignorCityCode: "",
        consignorCountyCode: "",
        consignorDetailAddress: "",
        consigneeProvinceCode: "",
        consigneeCityCode: "",
        consigneeCountyCode: "",
        consigneeDetailAddress: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        exportType: 1
      },
    };
  },
  created() {
    this.listQuery.userCode = this.$route.query.partyCode
      ? this.$route.query.partyCode
      : "";
    // this.findList();
  },
  methods: {
    findList() {
      this.listQuery.userCode = this.$route.query.partyCode
      this.loading = true;
      return new Promise(resolve => {
        getCommonRouteInfoList(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    changeConsigneeAreaList(value) {
      this.listQuery.consigneeProvinceCode = value[0];
      this.listQuery.consigneeCityCode = value[1];
      this.listQuery.consigneeCountyCode = value[2];
    },
    changeConsignorAreaList(value) {
      this.listQuery.consignorProvinceCode = value[0];
      this.listQuery.consignorCityCode = value[1];
      this.listQuery.consignorCountyCode = value[2];
    },
    // 排序
    sortList({ column, property, order }) {
      var str;
      switch (property) {
        case "consignorAddress":
          str = "consignorCountyCode";
          break;
        case "consigneeAddress":
          str = "consigneeCountyCode";
          break;
        default:
          str = property;
          break;
      }
      if (order) {
        this.listQuery.sortField = str;
        this.listQuery.sortType = order;
      } else {
        this.listQuery.sortField = "";
      }
      this.findList();
    },
    // 添加方法
    funcAdd(type,code) {
      this.modelAddFlag = true
      if(type=='add'){
        this.modalTitle = "新增"
      }
      else{
        this.modalTitle = "编辑"
      }
      this.$refs.addRef.getInfo(code)
    },
    // 删除方法
    funcDelete(codes) {
      this.$confirm("确认删除吗？")
        .then(_ => {
          delCommonRouteInfo({ codes }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        })
        .catch(_ => {});
    },
    // 增加组件的父方法
    fatherAdd() {
      this.modelAddFlag = false;
      this.findList();
    },
    // 公共取消
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case "add":
          this.modelAddFlag = false;
          break;
      }
    },
  }
};
</script>

<style lang="scss" scoped>

</style>
